/* eslint global-require: off, no-console: off, promise/always-return: off */

/**
 * This module executes inside of electron's main process. You can start
 * electron renderer process from here and communicate with the other processes
 * through IPC.
 *
 * When running `npm run build` or `npm run build:main`, this file is compiled to
 * `./src/main.js` using webpack. This gives us some performance wins.
 */
import path from 'path';
import { app, BrowserWindow, shell, ipcMain, screen, dialog ,} from 'electron';
import { autoUpdater, CancellationToken } from 'electron-updater';
// import log from 'electron-log';
import MenuBuilder from './menu';
import { resolveHtmlPath, toBuffer } from './util';
import { ffmpegDelFile, ffmpegSaveFile, ffmpegReadFile, ffmpegCommand } from './ffmpeg';
import { batchDownloadImages } from './downloadZip';
import barrages from './barrages';
import deviceId from './deviceId'
import axios from "axios";
import jsonData from '../../package.json'
import envInfo from '../../envInfo'
import { UpdateFlags, UpdaterEvents } from '../constants/update';
import Log from "../logger"
import mainLog from '../logger/main';

Log.init(mainLog);
const log = Log.scope('main')


// 主进程处理log
ipcMain.handle('Log', (event, level, module, args)=> {
  mainLog(module, level, args)
  // const userLog = log.scope(module)
  // userLog[level](...args);
})

log.info('设备id', deviceId())

ipcMain.on('get-mac-address', (event) => {
  event.sender.send('mac-address-reply', deviceId());
});

ipcMain.on('isFullScreen', (event) => {
  event.sender.send('isFullScreen', mainWindow?.isFullScreen());
});

//监听爬虫
ipcMain.on('handleBarrages', async (event, arg: any) => {
  log.info("互动规则ipc:" + arg)
  barrages(arg)
})

const gotTheLock = app.requestSingleInstanceLock()
if (!gotTheLock) {
  app.quit()
}


function pkgCheck(window) {
  const url = `${envInfo.apiUrl}/coreService/v1/pkg/check`;
  axios({
    url,
    headers:{
      bid: envInfo.bid,
      'channel-id': envInfo.channelId
    },
    method: "POST",
    data: {
      "bid": envInfo.bid,
      "channelId": envInfo.channelId,
      "osType": "windows",
      "versionCode":jsonData.version,
      "versionNumber": jsonData.versionNumber
    }
  }).then((response) => {
    log.info('查看版本更新')
    response.data
    if (response.data.code === 0) {
      if (response.data.data.upgradeFlag !== 0) {
        if (!response.data.data.newVersion.pkgUrl) return
        checkUpdate(response.data.data.newVersion.pkgUrl, response.data.data.upgradeFlag,window)
      }
    }

  }).catch((err) => {
    log.error('版本更新接口失败')
  })
}

function checkUpdate(url: string, upgradeFlag: number,window) {

  autoUpdater.setFeedURL(url)
  autoUpdater.allowDowngrade = true
  autoUpdater.autoDownload = false

  //检测更新
  autoUpdater.checkForUpdates()

  autoUpdater.once('checking-for-update', res => {
    log.info("获取版本信息:" + res)
  })

  autoUpdater.once('update-not-available', res => {
    log.info("没有可更新版本:" + res)
  })

  autoUpdater.on('download-progress', res => {
    log.info("下载监听:" + res)
    mainWindow?.webContents.send(UpdaterEvents.UPDATE_PROGRESS, res);
  })

  autoUpdater.once('update-downloaded', res => {
    log.info("下载完成:", res)
    // if (upgradeFlag === 2) {
    //   autoUpdater.quitAndInstall()
    //   app.quit()
    // }
    mainWindow?.webContents.send(UpdaterEvents.UPDATE_COMPLETED, res);
   })


  //监听'error'事件
  autoUpdater.once('error', (err) => {
    log.error('autoUpdater error', err)
  })


  // const options = {
  //   type: '正在更新中',
  //   buttons: ['确认'],
  //   defaultId: 0,
  //   message: '更新中请稍后',
  //   noLink: true
  // };

  //监听'update-available'事件，发现有新版本时触发
  autoUpdater.once('update-available', (res) => {
    const cancellationToken = new CancellationToken()

    ipcMain.once(UpdaterEvents.UPDATE_START, () => {
      autoUpdater.autoDownload = true
      autoUpdater.downloadUpdate(cancellationToken);
    })

    ipcMain.once(UpdaterEvents.UPDATE_INSTALL, () => {
      autoUpdater.quitAndInstall();
      app.quit();
    })

    ipcMain.once(UpdaterEvents.UPDATE_CANCEL, () => {
      cancellationToken?.cancel();
      // 强制更新取消时，关闭客户端
      if (upgradeFlag === UpdateFlags.FORCE) {
        app.quit();
      }
    })

    mainWindow?.webContents.send(UpdaterEvents.UPDATE_AVAILABLE,res);

    // dialog.showMessageBox(window,{
    //   type: 'info',
    //   title: '发现新版本',
    //   message: '是否立即下载，下载完成后下次启动将自动更新？',
    //   noLink: false,
    //   cancelId: 1,
    //   buttons: ['确认','取消']
    // }).then((buttonIndex) => {
    //   if (buttonIndex.response === 0) {  //选择是，则退出程序，安装新版本
    //     autoUpdater.autoDownload = true
    //     autoUpdater.downloadUpdate()
    //     // if (upgradeFlag === 2) {
    //     mainWindow?.webContents.send(UpdaterEvents.UPDATE_AVAILABLE,res);
    //     // }
    //   } else {
    //     autoUpdater.autoDownload = false
    //     if(upgradeFlag === 2) {
    //       app.quit()
    //     }
    //   }
    // })
  })

  //默认会自动下载新版本，如果不想自动下载，设置autoUpdater.autoDownload = false

  //监听'update-downloaded'事件，新版本下载完成时触发

}

let mainWindow: BrowserWindow | null = null;

ipcMain.on('ipc-example', async (event, arg) => {
  const msgTemplate = (pingPong: string) => `IPC test: ${pingPong}`;
  log.info('ipc-example', msgTemplate(arg))
  event.reply('ipc-example', msgTemplate('pong'));
});

// 批量转换音频存到本地
ipcMain.on('ffmpeg-dell-file', async () => {
  ffmpegDelFile();
});

// 批量转换音频存到本地
ipcMain.on('ffmpeg-save-file', async (event, audioList) => {
  ffmpegSaveFile((type: string, obj?: {errMsg: string, stdout: any, stderr: any}) => {
    event.reply('ffmpeg-save-file-reply', type, obj)
  }, audioList);
});

// 通过name读取本地转换完成的pcm文件
ipcMain.on('audio-file-message', async (event, id) => {
  ffmpegReadFile((chunk) => {
    event.reply('audio-file-reply', chunk)
  }, id);
});


// 音频经过ffmpeg转码
ipcMain.on('ffmpeg-message', async (event, url) => {
  ffmpegCommand((chunk) => {
    event.reply('ffmpeg-reply', chunk)
  }, url).run();
});

// 对前端的buffer进行base64编码
ipcMain.on('base64-message', async (event, { origin, buffer}) => {
  event.reply('base64-reply', {
    origin,
    chunk: toBuffer(buffer).toString('base64')
  })
});

// 对前端的buffer进行base64编码-预览页
ipcMain.on('base64-message-preview', async (event, { origin, buffer}) => {
  mainWindow?.webContents.send('base64-reply-preview', {
    origin,
    chunk: toBuffer(buffer).toString('base64')
  })
});

/**
 * 设置窗口大小
 */
ipcMain.on('setWindow', async (event, arg) => {
  log.info("ipcMain.on setWindow 设置窗口大小", arg)

  // mainWindow?.setFullScreen(false)
  // setTimeout(() => {
  mainWindow?.setFullScreen(false)
  mainWindow?.restore();
  mainWindow?.center();
  mainWindow?.setMinimumSize(arg.width, arg.height);
  // mainWindow?.setContentSize(arg.width, arg.height)
  mainWindow?.setSize(arg.width, arg.height, false);
  mainWindow?.center();
  // mainWindow?.setResizable(true);

    // if (arg.width !== 452) {
    //   const { width, height } = screen.getPrimaryDisplay().workAreaSize
    //   mainWindow?.setMinimumSize(arg.width, arg.height);
    //   // mainWindow?.setResizable(true);

    //   // mainWindow?.setMaximumSize(width, height);

    // } else {
    //   // mainWindow?.setMaximumSize(arg.width, arg.height);
    //   // 为登录窗口时，如果之前是全屏，退出全屏
    //   setTimeout(() => {
    //     mainWindow?.setResizable(false);
    //     if (mainWindow) mainWindow.center()
    //   }, 200)
    //   // const isFullScreen = mainWindow?.isFullScreen()
    //   // if (isFullScreen) mainWindow?.setFullScreen(!mainWindow?.isFullScreen())
    // }
    // if (mainWindow) mainWindow.center()
  // }, 100)

});


ipcMain.on('download', async (event, arg: any) => {
  const options = {
    title: '保存文件',
    defaultPath: `${arg.name}.zip`,
    buttonLabel: '保存',
    filters: [
      { name: 'ZIP Files', extensions: ['zip'] },
    ],
  };
  const filePath = await dialog.showSaveDialog(null, options);

  if (!filePath.canceled) {
    await batchDownloadImages(arg.urls, filePath.filePath)
  }
})

/**
 * 操作事件
 */
ipcMain.on('action', async (event, arg) => {
  log.info('操作事件', arg.type)
  if (arg.type === 'close') {
    mainWindow?.close()
    mainWindow?.destroy()
  }
  if (arg.type === 'minimize') {
    mainWindow?.minimize()
  }
  if (arg.type === 'openExternal') {
    shell.openExternal(arg.url)
  }
  if (arg.type === 'fullScreen') {
    const isFullScreen = mainWindow?.isFullScreen()
    if (!isFullScreen) {
      // const { width, height } = screen.getPrimaryDisplay().workAreaSize
      // mainWindow?.setMaximumSize(width, height);
      // mainWindow?.setSize(width, height)
      // mainWindow?.setContentSize(width, height)
    } else {


      // mainWindow?.setMinimumSize(1366, 768);
      // mainWindow?.setContentSize(1366, 768)
      // mainWindow?.setMaximumSize(1366, 768);
      // mainWindow?.setSize(1366, 768)
      // mainWindow?.setMaximumSize(1366, 768);
    }

    mainWindow?.setFullScreen(!mainWindow?.isFullScreen())

    /**
     * 监听esc按键退出全屏
     */
    // globalShortcut.register('ESC', () => {
    //   mainWindow?.setMaximumSize(1366, 768);
    //   mainWindow?.setSize(1366, 768)
    //   mainWindow?.setContentSize(1366, 768)
    //   mainWindow?.setFullScreen(false)
    //   event.sender.send('isFullScreen', false);
    // })
    mainWindow?.center()
  }

  if (arg.type === 'maximize') {
    if (mainWindow?.isMaximized()) {
      mainWindow?.restore();
    } else {
      mainWindow?.maximize()
    }
  }
})

/** 检测更新 */
ipcMain.on(UpdaterEvents.UPDATE_CHECK, async (event, arg) => {
  pkgCheck(mainWindow)
})


if (process.env.NODE_ENV === 'production') {
  const sourceMapSupport = require('source-map-support');
  sourceMapSupport.install();
}

const isDebug = process.env.NODE_ENV === 'development' || envInfo.opentools === 'true';

if (isDebug) {
  require('electron-debug')();
}

// const installExtensions = async () => {
//   const installer = require('electron-devtools-installer');
//   const forceDownload = !!process.env.UPGRADE_EXTENSIONS;
//   const extensions = ['REACT_DEVELOPER_TOOLS'];

//   return installer
//     .default(
//       extensions.map((name) => installer[name]),
//       forceDownload
//     )
//     .catch();
// };

const createWindow = async () => {
  if (isDebug) {
    // await installExtensions();
  }

  const RESOURCES_PATH = app.isPackaged
    ? path.join(process.resourcesPath, 'assets')
    : path.join(__dirname, '../../assets');

  const getAssetPath = (...paths: string[]): string => {
    return path.join(RESOURCES_PATH, ...paths);
  };

  mainWindow = new BrowserWindow({
    show: false,
    width: 1366,
    height: 768,
    // minHeight: 768,
    // minWidth: 1366,
    icon: getAssetPath('icon.png'),
    frame: false,
    center: true,
    // opacity: 0,
    // transparent: true,// 此属性影响最大化,会导致全屏后无法退出
    nodeIntegration: true,  //允许渲染进程使用Nodejs
    contextIsolation: false, //允许渲染进程使用Nodejs
    webPreferences: {
      preload: app.isPackaged
        ? path.join(__dirname, 'preload.js')
        : path.join(__dirname, '../../.erb/dll/preload.js'),
      webSecurity: false
    },
  });
  let previewWindow = null;
  // 创建预览窗口
  ipcMain.on('preview-window-create', async (event, arg) => {
    const width = Number(arg.resolutionArr[0]) -12
    const height = Number(arg.resolutionArr[1])
    if(previewWindow){
      return false
    }
    previewWindow = new BrowserWindow({
      width: width,
      height: height,
      maxWidth: width,
      maxHeight: height,
      minWidth: width,
      minHeight: height,
      enableLargerThanScreen: true,
      alwaysOnTop: true,
      // parent: mainWindow,
      modal:true,
      resizable: false,
      frame: false,
      // darkTheme: true,
      // backgroundColor: '#000',
      webPreferences: {
        preload: app.isPackaged
          ? path.join(__dirname, 'preload.js')
          : path.join(__dirname, '../../.erb/dll/preload.js'),
        webSecurity: false
      },
      // modal: true,
      // show: false
    });
    if (process.env.NODE_ENV === 'development') {
      previewWindow.loadFile(path.join(__dirname, '../../public/preview.html'));
    } else {
      previewWindow.loadURL(`file://${path.resolve(__dirname, '../renderer/', 'preview.html')}`);
    }
    // 关闭预览窗口
    ipcMain.on('close-preview-window', async (event, arg) => {
      previewWindow.close()
    })

    // 获取直播url
    previewWindow.on('ready-to-show', () => {
      log.info('预览窗口ready-to-show')
      // 重新设置一下width、height，使其超出屏幕
      setTimeout(() => {
        previewWindow?.setSize(width, height)
      })
      previewWindow.webContents.send('live-preview-info', arg)
      if (envInfo.isDebug){
        // 打开控制台
        previewWindow.webContents.openDevTools();
      }
      // // 打开控制台
    //   previewWindow.webContents.openDevTools();
      // previewWindow.setTitle(`直播画面（分辨率为${arg.resolutionArr[0]}*${arg.resolutionArr[1]} px）`);
    })
    previewWindow.on('closed', () => {
      event.reply('preview-window-close');
      previewWindow = null;
    });
    // 监听img更新
    ipcMain.on('refresh-preview-info', (event, imgInfo) => {
      previewWindow?.webContents.send('refresh-preview-info', imgInfo)
    })
  })
  mainWindow.loadURL(resolveHtmlPath('index.html'));
  // mainWindow.loadURL(resolveHtmlPath('http://172.16.189.64:1212/'));
  // mainWindow.webContents.openDevTools();

  if (envInfo.opentools === 'true') {
    mainWindow.webContents.openDevTools();
  }

  mainWindow.on('ready-to-show', () => {
    if (!mainWindow) {
      throw new Error('"mainWindow" is not defined');
    }
    if (process.env.START_MINIMIZED) {
      mainWindow.minimize();
    } else {
      mainWindow.show();
    }
  });

  mainWindow.on('closed', () => {
    mainWindow = null;
  });

  mainWindow.on('enter-full-screen', (event) => {
    event.sender.send('isFullScreen', true);
  });

  // 监听退出全屏状态事件
  mainWindow.on('leave-full-screen', (event) => {
    event.sender.send('isFullScreen', false);
  });

  mainWindow.on('maximize', function (event) {
    event.sender.send('main-window-max', mainWindow?.isFullScreen());
  })
  mainWindow.on('unmaximize', function (event) {
    event.sender.send('main-window-unmax', mainWindow?.isFullScreen());
  })
  mainWindow.on('close', function (event) {
    event.sender.send('stop-live')
  });
  const menuBuilder = new MenuBuilder(mainWindow);
  menuBuilder.buildMenu();

  // Open urls in the user's browser
  mainWindow.webContents.setWindowOpenHandler((edata) => {
    shell.openExternal(edata.url);
    return { action: 'deny' };
  });

  // mainWindow.webContents.send('update-counter', 1)

  // checkUpdate('http://172.16.189.64:8080/', 1)

};

app.on('window-all-closed', () => {
  if (process.platform !== 'darwin') {
    app.quit();
  }
});

app
  .whenReady()
  .then(() => {
    createWindow();
    app.on('activate', () => {
      // On macOS it's common to re-create a window in the app when the
      // dock icon is clicked and there are no other windows open.
      if (mainWindow === null) createWindow();
      if (mainWindow) mainWindow.center()
    });
  })
  .catch((err => {
    log.error('app whenReady error', err)
  }));


  app.on('ready', async () => {
    // 渲染进程崩溃
    app.on('renderer-process-crashed', (event, webContents, killed) => {
      log.error(
        `APP-ERROR:renderer-process-crashed; event: ${JSON.stringify(event)}; webContents:${JSON.stringify(
          webContents
        )}; killed:${JSON.stringify(killed)}`
      )
    })

    // GPU进程崩溃
    app.on('gpu-process-crashed', (event, killed) => {
      log.error(`APP-ERROR:gpu-process-crashed; event: ${JSON.stringify(event)}; killed: ${JSON.stringify(killed)}`)
    })

    // 渲染进程结束
    app.on('render-process-gone', async (event, webContents, details) => {
      log.error(
        `APP-ERROR:render-process-gone; event: ${JSON.stringify(event)}; webContents:${JSON.stringify(
          webContents
        )}; details:${JSON.stringify(details)}`
      )
    })

    // 子进程结束
    app.on('child-process-gone', async (event, details) => {
      log.error(`APP-ERROR:child-process-gone; event: ${JSON.stringify(event)}; details:${JSON.stringify(details)}`)
    })
  })

